import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'detection-design',
  templateUrl: './detection-design.component.html',
  styleUrls: ['./detection-design.component.scss'],
})
export class DetectionDesignComponent {
  val: string = '';

  oldVal = '';

  designVal: number[] = [];

  editing = false;

  inited = false;

  @Input()
  set initValue(val: string | undefined) {
    if (val && !this.inited) {
      this.inited = true;
      setTimeout(() => {
        this.val = val.replaceAll('<br/>', ' ').replaceAll('&ensp;', ' ');
        this.onValChange();
      }, 100);
    }
  }

  @Input()
  disable: boolean = false;

  @Output()
  designValChange: EventEmitter<number[]> = new EventEmitter<number[]>();

  onValChange() {
    this.editing = false;
    if (this.val === this.oldVal) {
      return;
    }
    this.designVal = [];
    const numList = this.val
      .replaceAll('/', ' ')
      .split(' ')
      .map((item) => (item !== '' ? +item : NaN));
    for (const item of numList) {
      if (!isNaN(item)) {
        this.designVal.push(item);
      }
    }
    if (this.designVal.length > 2) {
      this.designVal = this.designVal.slice(0, 2);
    }
    this.val = this.designVal.join(' ');
    this.oldVal = this.val;
    this.designValChange.emit(this.designVal);
  }

  constructor() {}
}
